{
  "cartDetails": {
    "id": "ID",
    "proceedToCheckout": "Proceder al pago",
    "cartName": "Carrito de compras"
  },
  "cartItems": {
    "id": "ID",
    "description": "Artículo",
    "item": "Artículo",
    "itemPrice": "Precio",
    "quantity": "Cantidad",
    "quantityTitle": "La cantidad representa el número total de este artículo en tu carrito.",
    "total": "Total",
    "actions": "",
    "cartTotal": "Total del carrito ({{count}} artículo)",
    "cartTotal_other": "Total del carrito ({{count}} artículos)",
    "itemRemoved": "El artículo seleccionado ha sido eliminado. El total del carrito ha sido actualizado.",
    "caption": "Contenido del carrito de compras."
  },
  "orderCost": {
    "orderSummary": "Resumen",
    "subtotal": "Subtotal:",
    "shipping": "Envío:",
    "estimatedShipping": "Envío estimado:",
    "discount": "Ahorras:",
    "salesTax": "Impuesto de ventas:",
    "grossTax": "El total del pedido no incluye impuestos de",
    "grossIncludeTax": "El total del pedido incluye impuestos de",
    "total": "Total del pedido:",
    "toBeDetermined": "Por determinar"
  },
  "voucher": {
    "coupon": "¿Tienes un cupón?",
    "coupon_other": "Códigos de cupón",
    "couponLabel": "Ingresa un código promocional aquí",
    "apply": "Aplicar",
    "placeholder": "Código promocional",
    "applyVoucherSuccess": "{{voucherCode}} ha sido aplicado.",
    "removeVoucherSuccess": "{{voucherCode}} ha sido eliminado.",
    "anchorLabel": "Ingresa o elimina tu código de cupón",
    "vouchersApplied": "Cupones aplicados",
    "availableCoupons": "Cupones disponibles",
    "availableCouponsLabel": "Puedes agregar estos cupones a este pedido."
  },
  "saveForLaterItems": {
    "itemTotal": "Guardado para más tarde ({{count}} artículo)",
    "itemTotal_other": "Guardado para más tarde ({{count}} artículos)",
    "cartTitle": "Carrito",
    "saveForLater": "Guardar para más tarde",
    "moveToCart": "Mover al carrito",
    "stock": "Stock",
    "forceInStock": "En stock"
  },
  "clearCart": {
    "clearCart": "Limpiar carrito",
    "clearingCart": "Limpiando carrito...",
    "cartClearedSuccessfully": "Carrito activo limpiado con éxito.",
    "areYouSureToClearCart": "¿Estás seguro de que quieres limpiar este carrito?",
    "allItemsWillBeRemoved": "Todos los artículos en tu carrito activo serán eliminados."
  },
  "validation": {
    "cartEntriesChangeDuringCheckout": "Durante el pago encontramos problemas con tus entradas. Por favor revisa tu carrito.",
    "cartEntryRemoved": "{{name}} fue eliminado del carrito por estar agotado.",
    "productOutOfStock": "{{name}} ha sido eliminado del carrito debido a insuficiente stock.",
    "lowStock": "La cantidad ha reducido a {{quantity}} debido a insuficiente stock.",
    "reviewConfiguration": "Resuelve los problemas en la configuración de la entrada del carrito primero.",
    "configurationError": "Resuelve los problemas en la configuración de las entradas del carrito primero.",
    "pricingError": "La configuración de precios no está disponible actualmente. No es posible realizar el pago/enviar la cotización. Por favor, inténtalo de nuevo más tarde.",
    "unresolvableIssues": "La configuración del producto requiere entradas adicionales en el back end. Como resultado, no puedes continuar. Por favor, contacta al soporte.",
    "inProgress": "Procesando"
  }
}